import { AxiosResponse } from "./axios";
import { apiBodyParser } from "./helpers/apiBodyParser";
import { ApiPagination } from "./helpers/apiPagination";

// This class is a generic interface between the api raw response and the the UI
export class ApiResponse {
  response: object;
  data: any | any[];
  pagination?: ApiPagination;
  headers: { [key: string]: string | number };
  statusCode: number;
  errors?: any;

  constructor(response: AxiosResponse) {
    this.response = response;
    this.data = apiBodyParser(response).data;
    this.pagination = apiBodyParser(response).pagination;
    this.statusCode = response.status;
    this.headers = response.headers;
    this.errors = response.data.errors || response.data.error || undefined;
  }

  get isSuccess(): boolean {
    return this.statusCode >= 200 && this.statusCode < 300;
  }

  get errorMessages(): string[] {
    if (!this.errors) return [];
    if (typeof this.errors === "string") return [this.errors];
    return Object.values(this.data.errors);
  }
}
